module.exports = __webpack_public_path__ + "img/omerta.2324d258.svg";